import React from 'react';
import styled from 'styled-components';

interface IProps {
  open: boolean;
  setOpen: (arg0: boolean) => void;
}

interface IStyleProps {
  open: boolean;
}

const BurgerButton = styled.button<IStyleProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 15;

  &:focus {
    outline: none;
  }

  @media (min-width: 700px) {
    display: none;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background: #000;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? '0' : '1')};
      transform: ${({ open }) =>
        open ? 'translateX(-20px)' : 'translateX(0)'};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;

const Burger: React.FC<IProps> = ({ open, setOpen }) => (
  <BurgerButton open={open} onClick={() => setOpen(!open)}>
    <div></div>
    <div></div>
    <div></div>
  </BurgerButton>
);

export default Burger;